import React, { useState, useEffect } from 'react';
import Header from './Header';  
import MainContent from './MainContent/MainContentUser';  
import { useNavigate } from 'react-router-dom';
import '../Css/UserHomePage.css'; 

const UserHomePage = ({ userRole, onLogout }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const navigate = useNavigate();

  // Set initial selected option based on role
  useEffect(() => {
    const role = userRole || localStorage.getItem('role');
    
    if (!role) {
      // If no role found, redirect to signin
      onLogout();
      return;
    }
    
    // Set default selected option based on role
    if (role === 'admin') {
      setSelectedOption('option7');
    } else if (role === 'User-facturation') {
      setSelectedOption('option1-2');
    } else {
      setSelectedOption('option2-2');
    }
  }, [userRole, onLogout]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  const handleLogout = () => {
    onLogout();
    navigate('/signin');
  };

  const factureSubmited = () => {
    setSelectedOption('option1-2');
  };

  const ReservationSubmited = () => {
    setSelectedOption('option2-2');
  };

  // Render only when selectedOption is set
  if (!selectedOption) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="user-home-page">
      <Header
        selectedOption={selectedOption}
        onOptionClick={handleOptionClick}
        toggleSidebar={toggleSidebar}
        onLogedout={handleLogout}
        isVisible={isSidebarVisible}
      />
      <MainContent 
        selectedOption={selectedOption} 
        isSumited={factureSubmited} 
        isSumitedReserv={ReservationSubmited}
      />
    </div>
  );
};

export default UserHomePage;